import * as yup from "yup";
import { validationSchemas } from "./data";
export const moneyOutSchema = yup.object().shape({
  moneyOut: validationSchemas.name,
});
